import React from "react"
import { useTranslation } from "react-i18next"

import styled from "styled-components/native"

import { getDefaultProfileName } from "@treefort/lib/profiles"
import icons from "@treefort/tokens/app/icons"

import { useAsyncViewPropsForQueries } from "../hooks/use-async-view-props-for-queries"
import { useProfiles } from "../hooks/use-profiles"
import useUserInfo from "../hooks/use-user-info"
import { profilesOverlay } from "../lib/profiles"
import AsyncView from "./async-view"
import { Button } from "./button"
import Column from "./column"
import { ProfileButton } from "./profile-button"
import Row from "./row"
import Spacer from "./spacer"
import Text from "./text"

export const PROFILES_ACTION_BUTTON_WIDTH = 176
export const PROFILES_CONTENT_TOP_PADDING = 64
export const PROFILES_CONTENT_BOTTOM_PADDING = 64

const StyledButton = styled(Button)`
  display: block;
  width: ${PROFILES_ACTION_BUTTON_WIDTH}px;
`

export function ProfilesManageScreen() {
  const userInfo = useUserInfo()
  const profiles = useProfiles()
  const { t } = useTranslation()

  const asyncViewProps = useAsyncViewPropsForQueries([profiles, userInfo])

  return (
    <AsyncView {...asyncViewProps}>
      <Column>
        <Text textStyle="headingXLarge">{t("Manage profiles")}</Text>
        <Spacer size={PROFILES_CONTENT_TOP_PADDING} />
        <Row
          flexWrap="wrap"
          justifyContent="center"
          columnGap="large"
          rowGap="small"
          paddingHorizontal="large"
        >
          {userInfo.data ? (
            <ProfileButton
              key={userInfo.data.id}
              onPress={() =>
                profilesOverlay.requestOpen({ screen: { name: "edit" } })
              }
              text={getDefaultProfileName(userInfo) || t("Default profile")}
              profileImage={userInfo.data.profilePic}
              icon={icons.pencil}
            />
          ) : null}
          {profiles.data?.profiles.map((profile) => (
            <ProfileButton
              key={profile.id}
              onPress={() => {
                profilesOverlay.requestOpen({
                  screen: { name: "edit", params: { profileId: profile.id } },
                })
              }}
              text={profile.name}
              profileImage={profile.imageMedia.original.url}
              icon={icons.pencil}
            />
          ))}
          {profiles.data &&
          profiles.data.profiles.length < profiles.data.maxCount ? (
            <ProfileButton
              onPress={() =>
                profilesOverlay.requestOpen({ screen: { name: "add" } })
              }
              text={t("Add profile")}
              icon={icons.plus}
            />
          ) : null}
        </Row>
        <Spacer size={PROFILES_CONTENT_BOTTOM_PADDING} />
        <StyledButton
          id="manage-profiles-done"
          type="primary"
          onPress={
            !profiles.data?.profiles.length
              ? profilesOverlay.requestClose
              : () =>
                  profilesOverlay.requestOpen({ screen: { name: "select" } })
          }
        >
          {t("Done")}
        </StyledButton>
      </Column>
    </AsyncView>
  )
}
